import { VANCE_ERROR_CODE } from '../api/cartoonizeAPIService';

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CartoonizeService', cartoonizeService);

    function cartoonizeService(
        blockUI,
        ImageFiltersAPIService,
        MultipleFileUploadService,
        $window,
        $mdDialog,
        $timeout,
        MdDialogService
    ) {
        async function applyFilter(object = null, $scope, canvas) {
            const { imageSelected } = $scope;
            const targetObject = object ? object : imageSelected;

            if (targetObject.imageFile) {
                const blockUIMessage = 'Applying filter';
                blockUI.start(blockUIMessage);

                try {
                    const response = await ImageFiltersAPIService.cartoonizeImage(
                        $scope.apiKeys.vanceAi,
                        targetObject.imageFile
                    );
                    targetObject.oldVanceImageFile = targetObject.imageFile;
                    targetObject.imageFile = response;
                    await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [response], targetObject);
                    $scope.$apply(function () {
                        blockUI.stop();
                    });
                } catch (error) {
                    $window.rumReportError(error);
                    targetObject.oldVanceImageFile = null;

                    if (error?.code == VANCE_ERROR_CODE.invalid_token) {
                        $scope.showApiKeyInput.vanceAi = true;
                    }

                    $timeout(() => $scope.$apply());
                    blockUI.stop();

                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title(`VanceIA Error!`)
                            .textContent(
                                error.msg ||
                                    error ||
                                    `There seems to be an error with your VanceIA account, so the filter could not be applied to the image.`
                            )
                            .ok('OK!')
                    );
                } finally {
                    $scope.$apply(() => blockUI.stop());
                }
            }
        }

        return {
            applyFilter: applyFilter
        };
    }
})();
